import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgGift2 = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.85 11.033a.75.75 0 0 1 .75-.75h16.8a.75.75 0 0 1 .75.75v9.301a2.34 2.34 0 0 1-2.343 2.342H5.192a2.34 2.34 0 0 1-2.342-2.342zm1.5.75v8.551c0 .465.377.842.842.842h13.615a.84.84 0 0 0 .843-.842v-8.551z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 10.28a.75.75 0 0 1 .75.75v10.896a.75.75 0 0 1-1.5 0V11.03a.75.75 0 0 1 .75-.75"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.82 7.642a.84.84 0 0 0-.842.842v.957c0 .465.377.842.842.842h16.36a.84.84 0 0 0 .842-.842v-.957a.84.84 0 0 0-.842-.842zm-2.342.842A2.34 2.34 0 0 1 3.82 6.142h16.36a2.34 2.34 0 0 1 2.342 2.342v.957a2.34 2.34 0 0 1-2.342 2.342H3.82A2.34 2.34 0 0 1 1.478 9.44z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.342 2.471c.575-.636 1.458-.973 2.595-.973 1.57 0 2.782 1.04 3.554 2.111.77 1.067 1.26 2.38 1.26 3.283a.75.75 0 0 1-1.5 0c0-.49-.324-1.5-.977-2.406-.65-.902-1.469-1.488-2.337-1.488-.846 0-1.27.244-1.48.478-.218.241-.322.596-.284 1.028.039.435.219.878.47 1.2.26.333.511.438.67.438a.75.75 0 1 1 0 1.5c-.789 0-1.43-.476-1.851-1.014a3.85 3.85 0 0 1-.783-1.992c-.064-.729.096-1.535.663-2.165"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.726 4.486c-.653.906-.976 1.916-.976 2.406a.75.75 0 0 1-1.5 0c0-.904.49-2.216 1.259-3.283.772-1.072 1.984-2.111 3.554-2.111 1.137 0 2.02.337 2.595.973.567.63.728 1.436.663 2.165a3.85 3.85 0 0 1-.783 1.992c-.42.538-1.062 1.014-1.852 1.014a.75.75 0 0 1 0-1.5c.16 0 .41-.105.67-.438.252-.322.432-.765.47-1.2.04-.432-.065-.787-.282-1.028-.211-.234-.634-.478-1.48-.478-.869 0-1.688.586-2.338 1.488"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgGift2;
